import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen, faMoneyBillWave } from "@fortawesome/pro-regular-svg-icons";
import Popup from "components/popup/Popup";
import Portal from "elements/Portal";
import { TRefundType } from "api/rpc/2024-04/facilityAdmin/order/refund";

import "./refundTypeModal.scss";

export interface IRefundTypeModalProps {
  open: boolean;
  onSelect: (type: TRefundType) => void;
  onCancel: () => void;
}

const RefundTypeModal: React.FC<IRefundTypeModalProps> = ({ open, onSelect, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Portal isMounted={open}>
      <Popup
        open={open}
        type="info"
        title={t("Choose refund type")}
        description={t("Select whether to return items or return money only.")}
        onCancel={onCancel}
        hideFooter
        noFixedWidth
      >
        <div className="refund-type-option-grid">
          <button
            type="button"
            className={classNames("refund-type-option-card")}
            onClick={() => onSelect("item_return")}
          >
            <div className="refund-type-option-card__header">
              <span className="refund-type-option-card__icon refund-type-option-card__icon--items">
                <FontAwesomeIcon icon={faBoxOpen} />
              </span>
              <span className="refund-type-option-card__radio" />
            </div>
            <p className="refund-type-option-card__title">{t("Return items")}</p>
            <p className="refund-type-option-card__description">
              {t("Reverse sold quantities, department sales, and matching payments together.")}
            </p>
          </button>
          <button
            type="button"
            className={classNames("refund-type-option-card")}
            onClick={() => onSelect("payment_adjustment")}
          >
            <div className="refund-type-option-card__header">
              <span className="refund-type-option-card__icon refund-type-option-card__icon--money">
                <FontAwesomeIcon icon={faMoneyBillWave} />
              </span>
              <span className="refund-type-option-card__radio" />
            </div>
            <p className="refund-type-option-card__title">{t("Return money only")}</p>
            <p className="refund-type-option-card__description">
              {t("Does not change sales quantities or department sales. Uses an offsetting overpayment account.")}
            </p>
          </button>
        </div>
      </Popup>
    </Portal>
  );
};

export default RefundTypeModal;
